import { Weld, Scalars } from '@bechtel/types';

export interface WeldDetailsProps {
  close: () => void;
  weldList: Weld[];
}
export interface WeldDetailStyledProps {
  isActive: Scalars['Boolean'];
}
